export const FEATURE_NAME = '@zerops/zerops/core/client-user-base';
